(function () {
// Variables
var $990f3d0b1260b4d8$var$blocks = document.querySelectorAll(".related-income-fund-properties-grid");
for(var $990f3d0b1260b4d8$var$i = 0; $990f3d0b1260b4d8$var$i < $990f3d0b1260b4d8$var$blocks.length; $990f3d0b1260b4d8$var$i++){
    var $990f3d0b1260b4d8$var$twoColumns = function twoColumns() {
        if ($990f3d0b1260b4d8$var$resultsWrapper.classList.contains('lg:!grid-cols-3') || !$990f3d0b1260b4d8$var$resultsWrapper.classList.contains('lg:!grid-cols-2')) {
            $990f3d0b1260b4d8$var$resultsWrapper.classList.add('lg:!grid-cols-2');
            $990f3d0b1260b4d8$var$resultsWrapper.classList.remove('lg:!grid-cols-3');
            $990f3d0b1260b4d8$var$gridTwoColumnsButton.classList.add('active');
            $990f3d0b1260b4d8$var$gridThreeColumnsButton.classList.remove('active');
        }
    };
    var $990f3d0b1260b4d8$var$threeColumns = function threeColumns() {
        if ($990f3d0b1260b4d8$var$resultsWrapper.classList.contains('lg:!grid-cols-2') || !$990f3d0b1260b4d8$var$resultsWrapper.classList.contains('lg:!grid-cols-3')) {
            $990f3d0b1260b4d8$var$resultsWrapper.classList.add('lg:!grid-cols-3');
            $990f3d0b1260b4d8$var$resultsWrapper.classList.remove('lg:!grid-cols-2');
            $990f3d0b1260b4d8$var$gridThreeColumnsButton.classList.add('active');
            $990f3d0b1260b4d8$var$gridTwoColumnsButton.classList.remove('active');
        }
    };
    var $990f3d0b1260b4d8$var$block = $990f3d0b1260b4d8$var$blocks[$990f3d0b1260b4d8$var$i];
    var $990f3d0b1260b4d8$var$baseId = $990f3d0b1260b4d8$var$block.getAttribute('id');
    var $990f3d0b1260b4d8$var$gridTwoColumnsButton = document.getElementById($990f3d0b1260b4d8$var$baseId + 'ResultsTwoColumns');
    var $990f3d0b1260b4d8$var$gridThreeColumnsButton = document.getElementById($990f3d0b1260b4d8$var$baseId + 'ResultsThreeColumns');
    var $990f3d0b1260b4d8$var$resultsWrapper = document.getElementById($990f3d0b1260b4d8$var$baseId + 'Results');
    var $990f3d0b1260b4d8$var$mapTimeout = false;
    $990f3d0b1260b4d8$var$gridTwoColumnsButton.addEventListener('click', $990f3d0b1260b4d8$var$twoColumns);
    $990f3d0b1260b4d8$var$gridThreeColumnsButton.addEventListener('click', $990f3d0b1260b4d8$var$threeColumns);
}

})();
//# sourceMappingURL=related-income-fund-properties-grid.js.map
